module.exports = "/_next/static/images/8cef4633924fa1127d07d2ff4c92166e-foundersfund.png.webp";